<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/culture/mission/">
            <h3>Misión y visión /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (form.controls['title'].value || 'Editar misión') : 'Añadir misión' }}</h2>
            </div>
        </a>
    </div>
</div>

<div class="content form">
    <form [formGroup]="form">
        <h4>Título:</h4>
        <mat-form-field appearance="outline" id="title-form-field">
            <input matInput formControlName="title" placeholder="Ingrese el título">
            @if (form.controls['title'].invalid && form.controls['title'].touched) {
            <mat-error>
                El título es obligatorio
            </mat-error>
            }
        </mat-form-field>

        <h4>Descripción</h4>
        <quill-editor formControlName="description" [modules]="modules" [styles]="{height: '300px'}"></quill-editor>
        @if (form.controls['description'].invalid && form.controls['description'].touched) {
        <mat-error>
            La descripción es obligatoria
        </mat-error>
        }

        <div class="options-row">
            <mat-checkbox formControlName="is_vision">Destacado</mat-checkbox>
        </div>
    </form>

    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveChanges()">
            {{ isEditMode ? 'Guardar cambios' : 'Guardar' }}
        </button>
        <button mat-flat-button id="cancel" routerLink="/home/culture/mission">Cancelar</button>
    </div>
</div>